module.exports = __webpack_public_path__ + "static/media/aLINK-logo.1c00e7c4.png";